import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import SchemaIcon from '@mui/icons-material/Schema';
import { IconButton, Link, Stack } from '@mui/material';
import { useNavigate } from "react-router-dom";

import Service from '../../../util/Service';



export default function BackGroundManagerPanel(){

    const [lista, setLista] = React.useState();
    const navigate = useNavigate();

    React.useEffect(()=>{
        Service.GET("/api/security/backGroundTask/buscaTodos").then( r =>{
          console.log( r );
            setLista(r);
        })
    }, [])

    function formataData(sdt){
        if (!sdt) return '';
        const dt = new Date(sdt);
  
        return dt.toLocaleDateString();
      }
    return (
        <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Nome</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Data</TableCell>
            <TableCell align="right">Conf</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lista && lista.map((row) => (
            <TableRow
              key={row.ut.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.ut.nome}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.ut.status}
              </TableCell>
              

              <TableCell >{
                formataData(row.ut.dtCriacao)
              }</TableCell>
              
              <TableCell align="right">
                <IconButton aria-label="edit" onClick={ (() => navigate('../flowBackground/'+row.ut.id))} >
                    <SchemaIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    )

}